class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');

    // Open on hover for desktop pointer devices; touch/mobile keeps tap-to-toggle.
    this.desktopQuery = window.matchMedia('(min-width: 990px) and (pointer: fine)');
    this.addEventListener('mouseenter', this.onMouseEnter.bind(this));
    this.addEventListener('mouseleave', this.onMouseLeave.bind(this));
    this.mainDetailsToggle
      .querySelector('summary')
      .addEventListener('click', this.onSummaryClick.bind(this));
  }

  get isDesktop() {
    return this.desktopQuery.matches;
  }

  open() {
    this.mainDetailsToggle.setAttribute('open', '');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', true);
  }

  onMouseEnter() {
    if (!this.isDesktop) return;
    clearTimeout(this.closeTimer);
    this.open();
  }

  onMouseLeave() {
    if (!this.isDesktop) return;
    // Delay closing so crossing the gap between the title and the absolutely
    // positioned panel doesn't shut the menu before the cursor reaches it.
    clearTimeout(this.closeTimer);
    this.closeTimer = setTimeout(() => this.close(), 150);
  }

  onSummaryClick(event) {
    // On desktop the menu is hover-driven; swallow the native click-toggle on a
    // mouse click so it doesn't immediately close a menu the pointer just opened.
    // detail === 0 means keyboard activation, which we leave alone for a11y.
    if (this.isDesktop && event.detail !== 0) event.preventDefault();
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);
